import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bd8d397"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { style: {"margin-right":"3rem"} }
const _hoisted_4 = { class: "shop-body" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "item-label" }
const _hoisted_8 = { class: "item-price-holder" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "item-price-text" }

import Inventory from "@/state/Inventory";
import GemCounter from "../shared/GemCounter.vue";
import CloseButton from "../shared/CloseButton.vue";
import ItemPurchaseOverlay from "@/components/overlays/ItemPurchaseOverlay.vue";
import ItemDescriptionOverlay from "@/components/overlays/ItemDescriptionOverlay.vue";
import { ItemDatabase } from "@/state/Gacha";
import { Item, ShopItem } from "@/types";
import RootShopItemList from "@/data/shop.json";
import { computed, Ref, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    inventory: null
  },
  emits: ["exit"],
  setup(__props: any, { emit }) {




const activePurchase: Ref<ShopItem | null> = ref(null);
const descriptionItemId = ref("");
const shopList: ShopItem[] = RootShopItemList;
const bodyBoxBgColours = [
  // copied from ItemDescriptionOverlay
  [],
  ["#505865", "#545a66", "#828e99"],
  ["#46565c", "#485d60", "#659973"],
  ["#525376", "#4e5d7c", "#489fb3"],
  ["#595482", "#716196", "#b684c8"],
  ["#695352", "#99694e", "#e3ad52"],
];

const descriptionItem = computed(() => ItemDatabase[descriptionItemId.value]);
function exit() {
  emit("exit");
}

function cssColours(item: Item): { [key: string]: string } {
  return {
    "--body-bg-gradient-start": bodyBoxBgColours[item.rarity][0],
    "--body-bg-gradient-middle": bodyBoxBgColours[item.rarity][1],
    "--body-bg-gradient-end": bodyBoxBgColours[item.rarity][2],
  };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (activePurchase.value)
      ? (_openBlock(), _createBlock(ItemPurchaseOverlay, {
          key: 0,
          "shop-item": activePurchase.value,
          inventory: __props.inventory,
          onExit: _cache[0] || (_cache[0] = ($event: any) => (activePurchase.value = null))
        }, null, 8, ["shop-item", "inventory"]))
      : _createCommentVNode("", true),
    (_unref(descriptionItem))
      ? (_openBlock(), _createBlock(ItemDescriptionOverlay, {
          key: 1,
          item: _unref(descriptionItem),
          onExit: _cache[1] || (_cache[1] = ($event: any) => (descriptionItemId.value = ''))
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(CloseButton, { onClicked: exit }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(GemCounter, {
            icon: "primogem.webp",
            text: __props.inventory.primos,
            "plus-sign": "",
            outline: "",
            nobackground: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (descriptionItemId.value = 'primogem'))
          }, null, 8, ["text"])
        ]),
        _createVNode(GemCounter, {
          icon: "starglitter.webp",
          text: __props.inventory.starglitter,
          outline: "",
          nobackground: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (descriptionItemId.value = 'starglitter'))
        }, null, 8, ["text"]),
        _createVNode(GemCounter, {
          icon: "stardust.webp",
          text: __props.inventory.stardust,
          outline: "",
          nobackground: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (descriptionItemId.value = 'stardust'))
        }, null, 8, ["text"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shopList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", {
              style: _normalizeStyle(cssColours(_unref(ItemDatabase)[item.id])),
              class: "shop-item-holder",
              onClick: ($event: any) => (activePurchase.value = item)
            }, [
              _createElementVNode("img", {
                src: require(`@/assets/images/${item.id}.webp`),
                class: "item-img"
              }, null, 8, _hoisted_6),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(ItemDatabase)[item.id].name), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  class: "cost-item-img",
                  src: require(`@/assets/images/${item.cost[0].id}.webp`)
                }, null, 8, _hoisted_9),
                _createElementVNode("p", _hoisted_10, _toDisplayString(item.cost[0].quantity), 1)
              ])
            ], 12, _hoisted_5)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})